import type { AppInboxToastStateItem } from '@src/components/GlobalToasts/AppInboxToast';
import { appNotificationSeverityToToastVariant } from './appNotificationSeverityToToastVariant';
import type { AppNotification } from './AppNotificationsMonitorContainer';
import { notificationTypeToDisplayInfo } from './notificationTypes/notificationTypeToDisplayInfo';

export type NotificationTransformerFn = (
  notification: AppNotification
) => Omit<AppInboxToastStateItem, 'id' | 'timeStamp'>;

const baseToastProps = (notification: AppNotification): Pick<AppInboxToastStateItem, 'id' | 'timeStamp'> => ({
  id: notification.NotificationID,
  timeStamp: notification.Timestamp,
});

export const getNotificationRenderInfo = (notification: AppNotification, throwError = true): AppInboxToastStateItem => {
  let matchResult: Omit<AppInboxToastStateItem, 'id' | 'timeStamp'>;

  // First try to find an exact match
  const transformer = notificationTypeToDisplayInfo[notification.Type];
  if (transformer) {
    matchResult = transformer.transform(notification);
  } else {
    if (throwError) {
      throw new Error(`No transformer registered for notification type "${notification.Type}"`);
    } else {
      matchResult = {
        appInboxToastType: notification.Type,
        variant: appNotificationSeverityToToastVariant(notification.Severity),
      } as unknown as AppInboxToastStateItem;
    }
  }

  return {
    ...baseToastProps(notification),
    ...matchResult,
  };
};
